import React from 'react';
import './PhaseProgressPanel.css';

interface PhaseProgressPanelProps {
  currentPhase: 'ksearch' | 'ksearch_complete' | 'acquisition';
  kSearchPatents: number;
  acquisitionStatus: 'not_started' | 'in_progress' | 'completed' | 'failed';
  acquisitionProgress: { acquired_count: number; total_patents: number; failed_count: number } | null;
}

const PhaseProgressPanel: React.FC<PhaseProgressPanelProps> = ({
  currentPhase,
  kSearchPatents,
  acquisitionStatus,
  acquisitionProgress,
}) => {
  const getPhaseIcon = (status: string): string => {
    // Windows-safe ASCII characters (no Unicode to prevent console errors)
    if (status === 'completed') return '[OK]';
    if (status === 'in_progress') return '[->]';
    if (status === 'failed') return '[X]';
    return '[ ]';
  };

  const getPhaseClass = (status: string): string => {
    if (status === 'completed') return 'phase-complete';
    if (status === 'in_progress') return 'phase-active';
    if (status === 'failed') return 'phase-failed';
    return 'phase-pending';
  };

  const phase1Status = currentPhase === 'ksearch' ? 'in_progress' : 'completed';
  const phase2Status = acquisitionStatus;

  return (
    <div className="phase-progress-panel">
      <div className="panel-header">
        <h3>Workflow Progress</h3>
      </div>

      <div className="phases-list">
        {/* Phase 1: KSearch */}
        <div className={`phase-item ${getPhaseClass(phase1Status)}`}>
          <div className="phase-icon">{getPhaseIcon(phase1Status)}</div>
          <div className="phase-info">
            <div className="phase-name">Phase 1: KSearch (Keyword Search)</div>
            <div className="phase-details">
              {phase1Status === 'completed' && kSearchPatents > 0
                ? `${kSearchPatents} patents identified`
                : phase1Status === 'in_progress'
                ? 'Exploring keywords and generating features...'
                : 'Not started'}
            </div>
          </div>
        </div>

        {/* Phase 2: Acquisition */}
        <div className={`phase-item ${getPhaseClass(phase2Status)}`}>
          <div className="phase-icon">{getPhaseIcon(phase2Status)}</div>
          <div className="phase-info">
            <div className="phase-name">Phase 2: Document Acquisition</div>
            <div className="phase-details">
              {phase2Status === 'in_progress' && acquisitionProgress ? (
                <>
                  <div className="progress-bar-container">
                    <div
                      className="progress-bar-fill"
                      style={{ width: `${(acquisitionProgress.acquired_count / acquisitionProgress.total_patents) * 100}%` }}
                    />
                  </div>
                  <span>
                    {acquisitionProgress.acquired_count}/{acquisitionProgress.total_patents} patents acquired
                    {acquisitionProgress.failed_count > 0 && ` (${acquisitionProgress.failed_count} failed)`}
                  </span>
                </>
              ) : phase2Status === 'completed' && acquisitionProgress ? (
                `${acquisitionProgress.acquired_count} patents acquired${acquisitionProgress.failed_count > 0 ? ` (${acquisitionProgress.failed_count} failed)` : ''}`
              ) : phase2Status === 'failed' ? (
                <span className="error-text">Acquisition failed</span>
              ) : (
                'Waiting for Phase 1 completion...'
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PhaseProgressPanel;
